/**
 * Jobs Controller
 * Defines the interface for our Jobs Object, which is our queue for running jobs.
 */
import api, { resolveWithStatus } from "@/services/api/api";

// Define all of your actions
const create = async (roverID: string, accessToken: any): Promise<any> => {
  try {
    const body = {
      roverID
    };

    const response = await api.post("/jobs", body, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export default {
  create
};
